import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { AppHeader } from '../../components/AppHeader';
import { AppFooter } from '../../components/AppFooter';
import { useUser } from '../../shared/use-user';
import { useChatView } from '../../shared/use-chat-view';
import styles from './AppLayout.css';

const cx = classnames.bind(styles);

function AppLayout({ children }) {
    const { userData } = useUser();
    const { isChatView } = useChatView();

    return (
        <div className={cx('root', { rootChatView: isChatView })}>
            <AppHeader isAuthenticated={userData.isAuthenticated} />
            <main className={cx('main', { mainChatView: isChatView })}>{children}</main>
            {!isChatView && <AppFooter className={styles.footer} />}
        </div>
    );
}

AppLayout.propTypes = {
    children: PropTypes.any.isRequired
};

export {
    AppLayout
};
